import React, { useState } from 'react'
import { useRouter } from 'next/router'
import { Box, Flex, Text, getPaletteColor, Button } from 'pcln-design-system'
import styled from 'styled-components'
import { ProductTabType } from '@/types'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import { PRODUCT_TABS } from './constants'
import ProductIcon from '@/components/ProductIcon'

const Wrapper = styled(Flex)`
  border-top: 1px solid ${getPaletteColor('border.base')};
`

const TabWithIcon = styled(Button)<{ isActive: boolean }>`
  &:hover {
    text-decoration: none;
  }
`

export default function Tabs({ onClick }: { onClick: (name: string) => void }) {
  const router = useRouter()
  const { query, pathname } = router

  const [activeTab, setActiveTab] = useState(
    router.query.tab ? router.query.tab : 'hotels'
  )

  const [hoveredTab, setHoverTab] = useState('')

  const handleMouseOver = (tabId: string) => {
    setHoverTab(tabId)
  }

  const handleMouseOut = () => {
    setHoverTab('')
  }

  const handleOnClick = (tab: ProductTabType) => {
    setActiveTab(tab.id)
    router.push(
      {
        pathname,
        query: {
          ...query,
          tab: tab.query.tab
        }
      },
      undefined,
      { shallow: true }
    )
    onClick(tab.id)
    analytics.fireEvent({
      action: 'tab',
      category: ANALYTICS_CATEGORY_HOME,
      label: tab.id
    })
  }

  return (
    <Wrapper role="tablist" aria-label="Types of travel">
      {PRODUCT_TABS.map(tab => {
        const isActive = tab.id === activeTab
        const isHoveredTab = tab.id === hoveredTab

        return (
          <TabWithIcon
            width={1}
            key={tab.id}
            variation="link"
            color={getPaletteColor('primary.base')}
            role="tab"
            py={3}
            isActive={isActive}
            aria-selected={isActive}
            aria-controls={`panel-${tab.id}`}
            aria-label={`Search for ${tab.id}`}
            id={`tab-${tab.id}`}
            data-testid={tab.autobotID}
            onMouseOver={() => handleMouseOver(tab.id)}
            onMouseOut={handleMouseOut}
            onClick={() => handleOnClick(tab)}
          >
            <Text textAlign="center" textStyle="heading6">
              <Flex alignItems="center" justifyContent="center">
                <Box display={['none', null, 'block']}>
                  <ProductIcon
                    name={tab.id}
                    isActive={isActive || isHoveredTab}
                    size="24px"
                  />
                </Box>
                <Text ml={2} mb="4px" fontWeight={isActive ? 'bold' : 100}>
                  {tab.tabText}
                </Text>
              </Flex>
            </Text>
          </TabWithIcon>
        )
      })}
    </Wrapper>
  )
}
